import { render } from "./Anatomia.vue?vue&type=template&id=712e7477&scoped=true"
import script from "./Anatomia.vue?vue&type=script&lang=js"
export * from "./Anatomia.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=712e7477&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712e7477"]])

export default __exports__